import React from "react";
import { connect } from "react-redux";

import SearchingPage from "./SearchingPage";
import { Creators } from "../../reducer";
import registrationStep from "../../registrationStep";

const withSynchronize = WrappedComponent =>
  class extends React.Component {
    componentDidMount() {
      this.props.synchronizeRegistration(this.props.currentRegistrationId);
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

// No next step since search will complete on the server
const withRegistration = registrationStep(SearchingPage, "searching");

export default connect(
  state => ({
    currentRegistrationId: state.registration.currentRegistrationId
  }),
  dispatch => ({
    synchronizeRegistration: registrationId =>
      dispatch(Creators.synchronizeRegistration(registrationId))
  })
)(withSynchronize(withRegistration));



// WEBPACK FOOTER //
// ./src/registration/components/Searching/index.js